<div [formGroup]="formGroup">
    <app-editor [control]="formGroup.controls['editor']" [isDraggable]="!isReadOnly" [isReadOnly]="isReadOnly" nz-input ngDefaultControl></app-editor>
</div>